import React, { Component } from "react";
import { check } from "../../resources/string/strings"
import { ReactComponent as IconLink } from "../../resources/image/ic_links.svg";

class Adapter extends Component {
  state = {
  };

  render() {
    const { links, title } = this.props;

    return (

      <div style={{ textAlign: "right" }} >

        <div style={{ color: "dimgrey", fontSize: 13, textAlign: "right" , marginBottom: 10}}>
          <IconLink
            className="p-0"
            width="25"
            height="25"
          />
          <span style={{ fontSize: 13, color: "dimgrey", marginRight: 6 }}>{title}</span>

        </div>

        {links.map((item) => (
          <div 
          key={item.title}
          style={{ fontSize: 13, color: "black", marginBottom: 10 }}>

            <span>{item.title}:</span>
      
            <span style={{marginRight: 10}}>
               <a style={{ height: 16, width: 70, fontSize: 13, textDecoration: "none" }}
                   className="clear-link m-0 p-0 "
                   href={item.link}
                   rel="noopener noreferrer"
                   target="_blank">{check}</a>

            </span>
            
            </div>
        ))}
      </div>
    );
  }
}

export default Adapter;
